module.exports = __webpack_public_path__ + "img/service_1.b68506c8.jpg";